export const MENTION_TOKEN_PATTERN =
  /\{\{@(?:team|agent|user)\.\d+\}\}|\{\{@workspace\}\}/gi;

export const buildMentionToken = item => {
  if (item.type === 'workspace') return '{{@workspace}}';
  if (item.type === 'team') return `{{@team.${item.id}}}`;
  return `{{@agent.${item.id}}}`;
};

export const parseMentionTokens = text => {
  const value = text || '';
  const teams = [...value.matchAll(/\{\{@team\.(\d+)\}\}/gi)].map(match =>
    Number(match[1])
  );
  const agents = [
    ...value.matchAll(/\{\{@agent\.(\d+)\}\}/gi),
    ...value.matchAll(/\{\{@user\.(\d+)\}\}/gi),
  ].map(match => Number(match[1]));

  return {
    teamIds: [...new Set(teams)],
    agentIds: [...new Set(agents)],
    workspace: /\{\{@workspace\}\}/i.test(value),
  };
};
